import { render } from "./ContentList.vue?vue&type=template&id=bc330a72&scoped=true&ts=true"
import script from "./ContentList.vue?vue&type=script&lang=ts"
export * from "./ContentList.vue?vue&type=script&lang=ts"

import "./ContentList.vue?vue&type=style&index=0&id=bc330a72&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc330a72"]])

export default __exports__